import { Component, inject, input, OnDestroy } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { PollTypeEnum } from "../../../../../../utils/enums/poll-type.enum";
import { IDevices, IDevicesForm } from "../../../../../../utils/interfaces/unit";
import { AlertService } from "../../../../../../shared/services/alert.service";
import {
  ConfirmationModalComponent
} from "../../../../../../shared/components/confirmation-modal/confirmation-modal.component";
import { Subject, take, takeUntil } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { UnitEditFormService } from "../../services/unit-edit-form.service";

@Component({
  selector: 'app-unit-devices-section',
  standalone: true,
  imports: [
    FormsModule,
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './unit-devices-section.component.html',
  styleUrl: './unit-devices-section.component.scss'
})
export class UnitDevicesSectionComponent implements OnDestroy {
  typePoll = input.required<PollTypeEnum>();
  form = input.required<FormArray<FormGroup<IDevicesForm>>>();

  formNewItem = new FormControl<string>('', Validators.required);

  private readonly alertService = inject(AlertService);
  private readonly dialog = inject(MatDialog);
  private readonly unsubscribe$ = new Subject<void>();

  private readonly unitEditFormService = inject(UnitEditFormService);

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get sectionLabel(): string {
    return this.typePoll() === PollTypeEnum.Satisfaction
      ? 'Dispositivos de pesquisa de satisfação'
      : 'Dispositivos de pesquisa de reserva de pratos';
  }

  add(): void {
    if (this.formNewItem.valid) {
      if (
        this.form()
          .getRawValue()
          .findIndex(
            (item) => item.name?.trim() === this.formNewItem.value?.trim()
          ) !== -1
      ) {
        this.alertService.danger('Já existe um dispositivo com esse nome.');

        return;
      }

      this.form().push(
        this.unitEditFormService.deviceCreate({
          id: null,
          name: this.formNewItem.value!.trim(),
          typePoll: this.typePoll(),
        })
      );

      this.formNewItem.reset();
    } else {
      this.formNewItem.markAllAsTouched();
    }
  }

  edit(index: number): void {
    this.form().controls.forEach((control, i) =>
      control.disable()
    );

    this.form().controls[index].enable();
  }

  delete(index: number): void {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '500px',
      data: {
        title: 'Excluir dispositivo',
        description: 'Deseja realmente excluir esse dispositivo?',
      },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) this.form().removeAt(index);
      });
  }

}
